import styled from 'styled-components';

export const LoadingDotContainer = styled.img`
  @keyframes DotAnimation {
    0% {
     visibility: hidden;
    }
    100% {
      visibility: visible;
    }
  }
  visibility: hidden;
  animation: DotAnimation 1s ease-in 1s forwards;
  display: block;
  margin: 12px auto;
  opacity: ${props => (props.show ? '1' : '0')};
  width: 50px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    padding-left: 8px;
    width: 45px;
  }
`;
